export enum PofType {
	crypto = "crypto",
	fiat = "fiat",
	both = "both"
}

export enum PofTypeId {
	pof = "pof",
	pow = "pow"
}

export enum PofDocTypes {
	PDF = "application/pdf",
	JPEG = "image/jpeg",
	PNG = "image/png",
	JPG = "image/jpg"
}
